import React from "react";
import {
  Shield,
  Lock,
  BadgeCheck,
  Database,
  Eye,
  FileLock2,
} from "lucide-react";

import "./LegalPages.css";

export default function TrustCenter() {
  const items = [
    {
      icon: <Shield size={22} />,
      title: "Security Monitoring",
      text: "Security Command Centre provides visibility into MFA activity, evidence access, login sessions, audit events, and suspicious actions.",
    },
    {
      icon: <Lock size={22} />,
      title: "Protected Authentication",
      text: "PresentPlus supports secure authentication flows, MFA enforcement, role-based access, login monitoring, and account protection.",
    },
    {
      icon: <BadgeCheck size={22} />,
      title: "School Data Isolation",
      text: "Each school environment operates independently with isolated data structures and permission enforcement.",
    },
    {
      icon: <Database size={22} />,
      title: "Secure Cloud Infrastructure",
      text: "Built on secure Firebase infrastructure with encrypted transmission, protected cloud services, and resilient hosting.",
    },
    {
      icon: <Eye size={22} />,
      title: "Operational Audit Visibility",
      text: "Administrative actions and security-sensitive operations are logged to support accountability and safeguarding.",
    },
    {
      icon: <FileLock2 size={22} />,
      title: "Compliance & Privacy",
      text: "PresentPlus is designed around GDPR principles, safeguarding expectations, ICO registration and modern school operational standards.",
    },
  ];

  return (
    <div className="pp-legal-page">
      <div className="pp-container">
        <div className="pp-legal-shell">
          <section className="pp-legal-hero">
            <div className="pp-legal-badge">TRUST CENTRE</div>

            <h1>Built for safeguarding, trust and resilience</h1>

            <p>
              PresentPlus combines attendance operations, parent engagement,
              audit visibility and secure school data controls into one modern platform.
            </p>
          </section>

          <section className="pp-trust-grid" aria-label="PresentPlus trust controls">
            {items.map((item) => (
              <article className="pp-trust-card" key={item.title}>
                <div className="pp-trust-icon">{item.icon}</div>
                <h2>{item.title}</h2>
                <p>{item.text}</p>
              </article>
            ))}
          </section>
        </div>
      </div>
    </div>
  );
}
